export default {
	namespaced: true,
	state: {
		endpoint: '/nbu/NbuReasonStop',
		name: 'NbuReasonStop',
		title: {
			single: 'NbuReasonStop',
			plural: 'NbuReasonStops'
		},
		icon: 'mdi-account',
		item: {},
		items: [
			{
				"id": "7",
				"code": null,
				"name": "виявлення фактів приймання страхових (перестрахових) премій та страхових (перестрахових) виплат страховими посередниками без дотримання вимог щодо відкриття та ведення поточного рахунку із спеціальним режимом використання, встановлених цим Законом",
				"caption": "виявлення фактів приймання страхових (перестрахових) премій та страхових (перестрахових) виплат страховими посередниками без дотримання вимог щодо відкриття та ведення поточного рахунку із спеціальним режимом використання, встановлених цим Законом",
				"isBlocked": false
			},
			{
				"id": "22",
				"code": null,
				"name": "Відкликання ліцензії страховика, реалізацію страхових продуктів якого здійснює страховий агент, додатковий страховий агент, якщо в таких страхових посередників немає договірних відносин з іншим страховиком про реалізацію страхових продуктів такого страховика.",
				"caption": "Відкликання ліцензії страховика, реалізацію страхових продуктів якого здійснює страховий агент, додатковий страховий агент, якщо в таких страхових посередників немає договірних відносин з іншим страховиком про реалізацію страхових продуктів такого страховика.",
				"isBlocked": false
			},
			{
				"id": "4",
				"code": null,
				"name": "відсутність інформації про проходження страховим посередником - фізичною особою та фізичною особою - підприємцем, керівником з реалізації страхового посередника - юридичної особи, страхового або перестрахового брокера - нерезидента, фізичної особи - підприємця навчання або підвищення кваліфікації у строки, визначені цим Законом",
				"caption": "відсутність інформації про проходження страховим посередником - фізичною особою та фізичною особою - підприємцем, керівником з реалізації страхового посередника - юридичної особи, страхового або перестрахового брокера - нерезидента, фізичної особи - підприємця навчання або підвищення кваліфікації у строки, визначені цим Законом",
				"isBlocked": false
			},
			{
				"id": "21",
				"code": null,
				"name": "Відсутність у страхового агента, додаткового страхового агента договірних відносин із страховиками, реалізацію страхових продуктів яких такі страхові посередники здійснюють більше ніж 12 місяців із дня припинення дії останнього договору зі страховиком.",
				"caption": "Відсутність у страхового агента, додаткового страхового агента договірних відносин із страховиками, реалізацію страхових продуктів яких такі страхові посередники здійснюють більше ніж 12 місяців із дня припинення дії останнього договору зі страховиком.",
				"isBlocked": false
			},
			{
				"id": "2",
				"code": null,
				"name": "встановлення фактів подання страховим посередником недостовірної інформації у документах, на підставі яких запис про таку особу внесено до Реєстру посередників",
				"caption": "встановлення фактів подання страховим посередником недостовірної інформації у документах, на підставі яких запис про таку особу внесено до Реєстру посередників",
				"isBlocked": false
			},
			{
				"id": "9",
				"code": null,
				"name": "встановлення фактів подання страховим посередником недостовірної інформації у документах, на підставі яких запис про таку особу та її керівників з реалізації внесено до Реєстру посередників",
				"caption": "встановлення фактів подання страховим посередником недостовірної інформації у документах, на підставі яких запис про таку особу та її керівників з реалізації внесено до Реєстру посередників",
				"isBlocked": false
			},
			{
				"id": "24",
				"code": null,
				"name": "інше",
				"caption": "інше",
				"isBlocked": false
			},
			{
				"id": "3",
				"code": null,
				"name": "наявність заборони на здійснення відповідної діяльності фізичною особою та фізичною особою - підприємцем за рішенням суду, що набрало законної сили",
				"caption": "наявність заборони на здійснення відповідної діяльності фізичною особою та фізичною особою - підприємцем за рішенням суду, що набрало законної сили",
				"isBlocked": false
			},
			{
				"id": "0",
				"code": null,
				"name": "Н/В",
				"caption": "Н/В",
				"isBlocked": false
			},
			{
				"id": "11",
				"code": null,
				"name": "невиконання страховим посередником та його керівниками з реалізації розпорядження Регулятора про усунення порушень",
				"caption": "невиконання страховим посередником та його керівниками з реалізації розпорядження Регулятора про усунення порушень",
				"isBlocked": false
			},
			{
				"id": "19",
				"code": null,
				"name": "Невідповідність брокера та/або його керівника, та/або його керівника з реалізації вимогам пунктів 1–3 частини першої статті 73 Закону про страхування та/або критеріям, визначеним у додатках 2, 3 до Положення про авторизацію страхових посередників та умови здійснення діяльності з реалізації страхових та/або перестрахових продуктів, затвердженого постановою Правління Національного банку України від 03.01.2025 № 2 (зі змінами)",
				"caption": "Невідповідність брокера та/або його керівника, та/або його керівника з реалізації вимогам пунктів 1–3 частини першої статті 73 Закону про страхування та/або критеріям, визначеним у додатках 2, 3 до Положення про авторизацію страхових посередників та умови здійснення діяльності з реалізації страхових та/або перестрахових продуктів, затвердженого постановою Правління Національного банку України від 03.01.2025 № 2 (зі змінами)",
				"isBlocked": false
			},
			{
				"id": "23",
				"code": null,
				"name": "Невідповідність вимогам пунктів 1–3 частини першої статті 73 Закону про страхування",
				"caption": "Невідповідність вимогам пунктів 1–3 частини першої статті 73 Закону про страхування",
				"isBlocked": false
			},
			{
				"id": "1",
				"code": null,
				"name": "невідповідність страхового посередника - фізичної особи та фізичної особи - підприємця, керівників з реалізації страхового посередника - юридичної особи та представництва страхового або перестрахового брокера - нерезидента, страхового посередника - фізичної особи - підприємця вимогам, передбаченим\u00A0підпунктом 1 частини першої статті 73\u00A0цього Закону",
				"caption": "невідповідність страхового посередника - фізичної особи та фізичної особи - підприємця, керівників з реалізації страхового посередника - юридичної особи та представництва страхового або перестрахового брокера - нерезидента, страхового посередника - фізичної особи - підприємця вимогам, передбаченим\u00A0підпунктом 1 частини першої статті 73\u00A0цього Закону",
				"isBlocked": false
			},
			{
				"id": "15",
				"code": null,
				"name": "невідповідність страхового посередника - фізичної особи та фізичної особи - підприємця, керівників з реалізації страхового посередника - юридичної особи та представництва страхового або перестрахового брокера - нерезидента, страхового посередника - фізичної особи - підприємця вимогам, передбаченим\u00A0підпунктом 2 частини першої статті 73\u00A0цього Закону",
				"caption": "невідповідність страхового посередника - фізичної особи та фізичної особи - підприємця, керівників з реалізації страхового посередника - юридичної особи та представництва страхового або перестрахового брокера - нерезидента, страхового посередника - фізичної особи - підприємця вимогам, передбаченим\u00A0підпунктом 2 частини першої статті 73\u00A0цього Закону",
				"isBlocked": false
			},
			{
				"id": "16",
				"code": null,
				"name": "невідповідність страхового посередника - фізичної особи та фізичної особи - підприємця, керівників з реалізації страхового посередника - юридичної особи та представництва страхового або перестрахового брокера - нерезидента, страхового посередника - фізичної особи - підприємця вимогам, передбаченим\u00A0підпунктом 3 частини першої статті 73\u00A0цього Закону",
				"caption": "невідповідність страхового посередника - фізичної особи та фізичної особи - підприємця, керівників з реалізації страхового посередника - юридичної особи та представництва страхового або перестрахового брокера - нерезидента, страхового посередника - фізичної особи - підприємця вимогам, передбаченим\u00A0підпунктом 3 частини першої статті 73\u00A0цього Закону",
				"isBlocked": false
			},
			{
				"id": "17",
				"code": null,
				"name": "невідповідність страхового посередника - фізичної особи та фізичної особи - підприємця, керівників з реалізації страхового посередника - юридичної особи та представництва страхового або перестрахового брокера - нерезидента, страхового посередника - фізичної особи - підприємця вимогам, передбаченим\u00A0підпунктом 4 частини першої статті 73\u00A0цього Закону",
				"caption": "невідповідність страхового посередника - фізичної особи та фізичної особи - підприємця, керівників з реалізації страхового посередника - юридичної особи та представництва страхового або перестрахового брокера - нерезидента, страхового посередника - фізичної особи - підприємця вимогам, передбаченим\u00A0підпунктом 4 частини першої статті 73\u00A0цього Закону",
				"isBlocked": false
			},
			{
				"id": "13",
				"code": null,
				"name": "нездійснення страховим посередником діяльності з надання посередницьких послуг протягом останніх 12 місяців",
				"caption": "нездійснення страховим посередником діяльності з надання посередницьких послуг протягом останніх 12 місяців",
				"isBlocked": false
			},
			{
				"id": "8",
				"code": null,
				"name": "неподання повідомлення про новий договір страхування відповідальності страхового посередника, передбачений статтею 74 цього Закону (якщо страховий посередник отримує страхові та/або перестрахові премії, страхові та/або перестрахові виплати)",
				"caption": "неподання повідомлення про новий договір страхування відповідальності страхового посередника, передбачений статтею 74 цього Закону (якщо страховий посередник отримує страхові та/або перестрахові премії, страхові та/або перестрахові виплати)",
				"isBlocked": false
			},
			{
				"id": "20",
				"code": null,
				"name": "Оголошення страхового посередника банкрутом і відкриття ліквідаційної процедури відповідно до Кодексу України з процедур банкрутства.",
				"caption": "Оголошення страхового посередника банкрутом і відкриття ліквідаційної процедури відповідно до Кодексу України з процедур банкрутства.",
				"isBlocked": false
			},
			{
				"id": "14",
				"code": null,
				"name": "подання страховим посередником заяви про виключення запису про нього з Реєстру посередників",
				"caption": "подання страховим посередником заяви про виключення запису про нього з Реєстру посередників",
				"isBlocked": false
			},
			{
				"id": "12",
				"code": null,
				"name": "порушення страховим посередником та його керівниками з реалізації вимог законодавства про запобігання та протидію легалізації (відмиванню) доходів, одержаних злочинним шляхом, фінансуванню тероризму та фінансуванню розповсюдження зброї масового знищення",
				"caption": "порушення страховим посередником та його керівниками з реалізації вимог законодавства про запобігання та протидію легалізації (відмиванню) доходів, одержаних злочинним шляхом, фінансуванню тероризму та фінансуванню розповсюдження зброї масового знищення",
				"isBlocked": false
			},
			{
				"id": "18",
				"code": null,
				"name": "Порушення страховим та/або перестраховим брокером заборон, передбачених частиною сьомою статті 78 Закону про страхування.",
				"caption": "Порушення страховим та/або перестраховим брокером заборон, передбачених частиною сьомою статті 78 Закону про страхування.",
				"isBlocked": false
			},
			{
				"id": "5",
				"code": null,
				"name": "проведення державної реєстрації припинення страхового посередника як юридичної особи, представництва страхового або перестрахового  брокера - нерезидента або державної реєстрації припинення підприємницької діяльності страхового посередника, який є фізичною особою - підприємцем",
				"caption": "проведення державної реєстрації припинення страхового посередника як юридичної особи, представництва страхового або перестрахового  брокера - нерезидента або державної реєстрації припинення підприємницької діяльності страхового посередника, який є фізичною особою - підприємцем",
				"isBlocked": false
			},
			{
				"id": "10",
				"code": null,
				"name": "систематичне порушення страховим посередником та його керівниками з реалізації законодавства про реалізацію страхових та перестрахових продуктів та/або про захист прав споживачів",
				"caption": "систематичне порушення страховим посередником та його керівниками з реалізації законодавства про реалізацію страхових та перестрахових продуктів та/або про захист прав споживачів",
				"isBlocked": false
			},
			{
				"id": "6",
				"code": null,
				"name": "смерть фізичної особи, фізичної особи - підприємця або визнання такої особи безвісно відсутньою чи померлою за рішенням суду",
				"caption": "смерть фізичної особи, фізичної особи - підприємця або визнання такої особи безвісно відсутньою чи померлою за рішенням суду",
				"isBlocked": false
			}
		],
	},
}
